import React, { FC, useContext, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Icon, Card, Image, Grid, Button, Header, SemanticCOLORS, Popup, Divider } from 'semantic-ui-react';
import styled from 'styled-components'

import { ErrorManagement, ResponseManagement } from '../../../API';
import useRouter from '../../../hooks/useRouter';
import GlobalContext from '../../../contexts/GlobalContext';
import { RootDispatch, RootState } from '../../../store';
import Utility from '../../../Utility';
import { allSupplementsSelector, bookingAddedSupplements } from '../../../store/supplement'
import useResponsive from '../../../hooks/useResponsive';

import OptionExtraCarousel from '../../Carousels/OptionExtraCarousel';
import BookingCardSkeleton from './BookingCardSkeleton';
import { getOptionsList } from '../../../common/backend/supplement';
import BookingDateInfos from './BookingDateInfos';
import BookingAccordionDetails from './BookingAccordionDetails';
import BookingPriceInfos from './BookingPriceInfos';
import BookingDetailsAccordion from "../BookingAccordion/BookingDetailsAccordion";
import { totalBookingsPrice } from "../../../../src/store/booking";
import { useNavigate } from 'react-router-dom';

const mapProps = (state: RootState) => ({
  bookingCancel: state.booking.bookingCancel,
  accommodationServices: state.accommodation.accommodationServices,
  rateplans: state.rateplan.rateplans,
  cancellationConditions: state.rateplan.cancellationConditions,
  allSupplements: allSupplementsSelector(state),
  bookingAddedSupplements: bookingAddedSupplements(state),
  totalBookingsPrice: totalBookingsPrice(state),
  modal: state.modal,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  loadSupplement: dispatch.supplement.load,
  handleRedirectType: dispatch.authentication.handleRedirectType,
  handleModal: dispatch.modal.handleModal,
  updateSelectedBooking: dispatch.booking.updateSelectedBooking,
  updateAvailableOptions: dispatch.supplement.updateAvailableOptions,
})

type Props = {
  booking: any
  bookingIndex: number
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const BookingCard: FC<Props> = ({
  booking,
  bookingIndex,
  bookingCancel,
  allSupplements,
  accommodationServices,
  rateplans,
  cancellationConditions,
  totalBookingsPrice,
  handleModal,
  handleRedirectType,
  updateSelectedBooking,
  updateAvailableOptions,
}) => {
  const [globalContext] = useContext(GlobalContext) as any;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShortedDesc, setIsShortedDesc] = useState<boolean>(true);
  const router = useRouter();
  let navigate = useNavigate();

  const { isMobile, isTablet } = useResponsive();
  var droitModifResa = globalContext.establishment?.modifResa
  if (typeof globalContext.establishmentCollection[booking.establishmentId] != "undefined") {
    droitModifResa = globalContext.establishmentCollection[booking.establishmentId]?.modifResa
  }

  useEffect(() => {
    if (
      booking.status === "future" &&
      globalContext.displayControl.addOptionEarlyCheckIn
    ) {
      setIsLoading(true);
      // si multi etab
      let etabTemp = globalContext.establishment;
      if (typeof globalContext.establishmentCollection[booking.establishmentId] != "undefined") {
        etabTemp = globalContext.establishmentCollection[booking.establishmentId]
      }

      getOptionsList({
        bookingId: booking.id,
        organizationId: etabTemp.organizationId,
        establishmentId: etabTemp.id,
      })
        .then((response) => {
          ResponseManagement(
            response,
            () => updateAvailableOptions({ [booking.id]: response.data.data }),
            () => { }
          );
        })
        .catch((error) => {
          ErrorManagement(error, () => { });
        })
        .finally(() => setIsLoading(false));
    }
  }, [
    booking.status,
    booking.id,
    globalContext.displayControl.addOptionEarlyCheckIn,
  ]);

  if (isLoading) return <BookingCardSkeleton />;

  // Guard if accommodation not found
  if (!accommodationServices?.[booking.accommodationServiceId]) return null;

  // Display infos
  const accommodationService =
    accommodationServices[booking.accommodationServiceId];

  const isBookingCancellable =
    bookingCancel?.bookings?.[booking.id]?.isCancellable === true &&
    bookingCancel.bookingFolder.isCancellable;

  const btnDisabled = !isBookingCancellable ? true : false;
  //const popupCancelConditionDisabled  = typeof cancellationConditions?.[booking.cancellationConditionId] === 'undefined' && btnDisabled ? true : false
  const popupCancelConditionDisabled =
    typeof cancellationConditions?.[booking.cancellationConditionId] ===
      "undefined" ||
      !btnDisabled ||
      globalContext.authenticationStatus == 2
      ? true
      : false;

  // Style infos
  const statusData = Utility.getStatusBooking(
    booking.status,
    globalContext.translations
  ) as { status: string; color: SemanticCOLORS };

  const hasSupplement =
    globalContext.displayControl.addExtraEarlyCheckIn ||
    globalContext.displayControl.addOptionEarlyCheckIn;

  const colLeftColumn =
    booking.status === "future" &&
      allSupplements?.[booking.id].length > 0 &&
      hasSupplement
      ? 7
      : 16;

  const getShortedDescription = (desc) => {
    if (!desc) {
      return " - ";
    }
    if (allSupplements?.[booking.id].length === 0) {
      return desc;
    }
    if (isTablet) {
      return desc.shorted(400);
    }

    return desc.shorted(90);
  };

  // Open all details modal
  const handleClickAllDetails = () => {
    updateSelectedBooking({ id: booking.id, index: bookingIndex });
    handleModal({ bookingDetailsModal: true });
  };

  const handleIsShortDesc = () =>
    setIsShortedDesc((isShortedDesc) => !isShortedDesc);

  return (
    <Card fluid centered>
      <Card.Content>
        <Grid style={{ height: "100%" }} columns="equal">
          <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
            <Grid.Column
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              className="mb-4"
              computer={colLeftColumn}
              mobile={16}
            >
              <Grid columns="equal">
                <Grid.Row centered>
                  {/******************  IMAGE ***************/}
                  <Grid.Column computer={8} tablet={8} mobile={16}>
                    {isMobile && (
                      <>
                        <AccommodationName
                          name={rateplans?.[booking.rateplanId]?.name}
                        />
                        <p className="description-text text-center">
                          {statusData.status}{" "}
                          <Icon
                            size="small"
                            color={statusData.color}
                            name="circle"
                          />
                        </p>
                      </>
                    )}
                    <Image
                      centered
                      label={{
                        color: booking.status !== 'cancel' ? 'blue' : 'red',
                        content: accommodationService.name,
                        icon: "hotel",
                        ribbon: true,
                      }}
                      src={
                        Utility.imageExists(
                          accommodationService.photos[0]
                        ) /* TO DO image */
                      }
                      ui={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={8} mobile={16}>
                    <div>
                      {/* <p className="date">{sessionStorage.getItem('lang') === "FR" ? "Nom" : "Name"} : test</p> */}
                      {/* <h4 className="text-center">{globalContext.translations.amount}: {booking.priceTotal} {booking.currency}</h4> */}
                      {isMobile && (
                        <>
                          <BookingDateInfos
                            booking={booking}
                            bookingIndex={bookingIndex}
                          />
                          <BookingDetailsAccordion
                            title={globalContext.translations.description}
                          >
                            <div className="description-text" >
                              {globalContext.translations.description}:{" "}
                              {accommodationService.description !== ""
                                ? <div dangerouslySetInnerHTML={{ __html: accommodationService.description }} />
                                : " - "}

                            </div>
                          </BookingDetailsAccordion>
                        </>
                      )}
                      {!isMobile && (
                        <>
                          <AccommodationName
                            name={rateplans?.[booking.rateplanId]?.name}
                          />
                          <p className="description-text mt-2">
                            {statusData.status}{" "}
                            <Icon
                              size="small"
                              color={statusData.color}
                              name="circle"
                            />
                          </p>
                          <p className="description-text" dangerouslySetInnerHTML={{
                            __html: `${globalContext.translations.description} : &nbsp; ${isShortedDesc
                              ? getShortedDescription(
                                accommodationService.description
                              )
                              : accommodationService.description}`
                          }}>

                          </p>
                          {getShortedDescription(
                            accommodationService.description
                          ).length <
                            accommodationService.description.length && (
                              <div className="text-center">
                                <IconDesc
                                  onClick={handleIsShortDesc}
                                  name={isShortedDesc ? "angle down" : "angle up"}
                                />
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <div>
                <Card.Description>
                  {!isMobile && (
                    <BookingDateInfos
                      booking={booking}
                      bookingIndex={bookingIndex}
                    />
                  )}
                  <hr />
                  <BookingAccordionDetails
                    booking={booking}
                    accommodationServiceName={accommodationService.name}
                  />
                  <hr />
                  <BookingPriceInfos
                    booking={booking}
                    totalPrice={totalBookingsPrice[booking.id]}
                    handleClickAllDetails={handleClickAllDetails}
                  />
                </Card.Description>
              </div>
            </Grid.Column>
            {booking.status === "future" &&
              allSupplements?.[booking.id].length > 0 &&
              hasSupplement && (
                <Grid.Column
                  computer={9}
                  mobile={16}
                  style={{ background: "rgb(251, 251, 251)" }}
                >
                  <OptionExtraCarousel
                    className="option-extra-carousel"
                    supplements={allSupplements[booking.id]}
                    booking={booking}
                  />
                </Grid.Column>
              )}
          </Grid.Row>
        </Grid>
      </Card.Content>
      {booking.status === "future" && (
        <Card.Content extra>
          {droitModifResa && (
            <Button
              size="mini"
              primary
              className="btn-action-resa"
              onClick={() => {
                handleRedirectType(() => {
                  setTimeout(() => {
                    updateSelectedBooking({
                      id: booking.id,
                      cancellationConditionId: booking.cancellationConditionId,
                      index: bookingIndex,
                    });
                    handleModal({ updateBookingModal: true });
                  }, 0);
                });
              }}
              icon="edit"
              labelPosition="left"
              content={globalContext.translations.modifyMyBooking}
              disabled={btnDisabled}
            />
          )}

          <Popup
            wide="very"
            disabled={popupCancelConditionDisabled}
            trigger={
              <span className="ml-3 btn-action-resa-container">
                <Button
                  size="mini"
                  color="grey"
                  className="btn-action-resa"
                  onClick={() => {
                    handleRedirectType(() => {
                      setTimeout(() => {
                        updateSelectedBooking({
                          id: booking.id,
                          cancellationConditionId:
                            booking.cancellationConditionId,
                          index: bookingIndex,
                        });
                        handleModal({ cancelBookingModal: true });
                      }, 0);
                    });
                  }}
                  labelPosition="left"
                  icon="trash alternate"
                  content={globalContext.translations.cancelMyBooking}
                  disabled={btnDisabled}
                />
              </span>
            }
          >
            <Popup.Header>
              {Utility.ucFirst(
                globalContext.translations.cancellationConditionLabelTitle
              )}
              :{" "}
              {cancellationConditions?.[booking.cancellationConditionId]?.name}
            </Popup.Header>
            <Divider />
            <Popup.Content>
              {
                cancellationConditions?.[booking.cancellationConditionId]
                  ?.description
              }
            </Popup.Content>
          </Popup>

          {globalContext.displayControl.earlyCheckInForm && (
             <Button
              onClick={() => {
                  navigate(
                    `${Utility.getUrlBaseName()}/checkin/${ booking.bookingFolderId }`
                  );
              }}
              primary
              size="mini"
              floated="right"
              content={
                globalContext.translations.prechecking
                  ? Utility.ucFirst(globalContext.translations.prechecking)
                  : ""
              }
              className="ml-3"
              icon="right chevron"
              labelPosition="left"
              disabled={booking.status !== "future" ? true : false}
            />
          )}
        </Card.Content>
      )}
      {booking.status === 'pending' && isBookingCancellable &&
        <Card.Content extra>
          <Button
            size="mini"
            color="grey"
            className="btn-action-resa"
            onClick={() => {
              handleRedirectType(() => {
                setTimeout(() => {
                  updateSelectedBooking({ id: booking.id, cancellationConditionId: booking.cancellationConditionId, index: bookingIndex })
                  handleModal({ cancelBookingModal: true })
                }, 0)
              })
            }}
            labelPosition="left"
            icon="trash alternate"
            content={globalContext.translations.cancelBookingDRW}
          />
        </Card.Content>
      }
    </Card>
  );
};

const AccommodationName = ({ name }) => {
  return (
    <Header className="text-center" as="h4">
      {name ? name : '-'}
    </Header>
  )
}

const IconDesc = styled(Icon)`
  &:hover {
    cursor: pointer;
  }
`;

export default connect(mapProps, mapDispatch)(BookingCard)
